// extracted by mini-css-extract-plugin
export var button = "Form-module--button--866ff";
export var buttonRow = "Form-module--buttonRow--e8585";
export var cdsAssistiveText = "Form-module--cds--assistive-text--ac042";
export var cdsVisuallyHidden = "Form-module--cds--visually-hidden--46001";
export var dialog = "Form-module--dialog--a8440";
export var enter = "Form-module--enter--4448a";
export var enterActive = "Form-module--enterActive--bf772";
export var exit = "Form-module--exit--87fcf";
export var exitActive = "Form-module--exitActive--ec39b";
export var formContainer = "Form-module--form-container--e9e64";
export var hideFeedback = "Form-module--hide-feedback--def5a";
export var showFeedback = "Form-module--show-feedback--7ba66";
export var skeleton = "Form-module--skeleton--c9806";